import { useState } from 'react';
import { useParams } from 'react-router';

import { useQuery } from 'hooks/useQuery/useQuery';
import { QueryKeyEnum } from 'core/global.enum';
import {
  QueryKeyLocalStorageEnum,
  UsersLoginHistoryQueryKeysEnum,
  WantedHistoryQueryKeysEnum,
} from 'context/query/queryContext/QueryContext.enum';
import { useLocaleStoreQuery } from 'hooks/useLocaleStoreQuery/useLocaleStoreQuery';
import { useSavedPagination } from 'hooks/useSavedPagination/useSavedPagination';
import { fetchUserHistory } from 'api/users/users';

import { UserDetailsHistory } from './UserDetailsHistory';

export const UserDetailsHistoryContainer = () => {
  const { id } = useParams();

  const {
    storedQueries: { userHistory: userHistoryQuery },
    setQuery,
  } = useLocaleStoreQuery();

  const [userSearchQuery, setUserSearchQuery] = useState(userHistoryQuery?.query?.label || '');

  const { page, rowsPerPage, setPage, setRowsPerPage, setPaginationCount, storedQueryWithoutPagination } =
    useSavedPagination({
      queryKey: QueryKeyLocalStorageEnum.USER_HISTORY,
      resetPaginationDependencyArray: [userSearchQuery],
    });

  const { data: historyResponse, isLoading } = useQuery(
    [QueryKeyEnum.USER_HISTORY, storedQueryWithoutPagination, rowsPerPage, page, userSearchQuery],
    () => fetchUserHistory(id),
    {
      args: {
        ...storedQueryWithoutPagination,
        [UsersLoginHistoryQueryKeysEnum.QUERY]: userHistoryQuery.query?.value,
        [WantedHistoryQueryKeysEnum.LIMIT]: rowsPerPage,
        [WantedHistoryQueryKeysEnum.OFFSET]: rowsPerPage * page,
      },
      onSuccess: (response) => {
        setPaginationCount(response.count);
      },
    },
  );

  const onClearHistoryQuery = () => {
    setQuery(QueryKeyLocalStorageEnum.USER_HISTORY, {
      page,
      rowsPerPage,
    });
    setUserSearchQuery('');
  };

  return (
    <UserDetailsHistory
      historyResponse={historyResponse}
      isLoading={isLoading}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}
      userSearchQuery={userSearchQuery}
      setUserSearchQuery={setUserSearchQuery}
      onClearHistoryQuery={onClearHistoryQuery}
    />
  );
};
